import React from "react";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";

import SectionHeader from "./SectionHeader";
import CallToActionButton from "./CallToActionButton";

import "./styles/components/Popup.css";

const Popup = props => {
  return (
    <div className={props.openPopup ? "popup popup__open" : "popup"} id="popup">
      <div className="popup__content">
        <div onClick={props.closePopup} className="popup-close">
          &times;
        </div>
        <div className="popup__left">
          <img
            className="popup__img"
            src={props.image1}
            alt={props.altImage1}
          />
          <img
            className="popup__img"
            src={props.image2}
            alt={props.altImage2}
          />
        </div>
        <div className="popup__right">
          <SectionHeader
            marginBottom="small"
            headerAlign={props.headerAlign}
            colourPrimary={props.colourPrimary}
            colourSecondary={props.colourSecondary}
            title={props.headerTitle}
          />
          <h3 className="heading-tertiary">{props.subHeader}</h3>
          <div className="popup__text">{props.text}</div>
          <Link
            rel="noopener noreferrer"
            to={{ pathname: props.link }}
            target="_blank"
          >
            <CallToActionButton
              handleClick={() => {}}
              colourPrimary={props.colourPrimary}
              colourSecondary={props.colourSecondary}
              align={props.alignButton}
              text={props.buttonText}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

Popup.defaultProps = {
  openPopup: false,
  image1: "",
  altImage1: "",
  image2: "",
  altImage2: "",
  headerAlign: "center",
  headerTitle: "Popup Title",
  text:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.",
  alignButton: "center",
  buttonText: "Popup Button",
  link: "#"
};

Popup.propTypes = {
  image1: PropTypes.string.isRequired,
  altImage1: PropTypes.string.isRequired,
  image2: PropTypes.string.isRequired,
  altImage2: PropTypes.string.isRequired,
  headerAlign: PropTypes.string.isRequired,
  headerTitle: PropTypes.string.isRequired,
  alignButton: PropTypes.string.isRequired,
  buttonText: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired
};

export default Popup;



// WEBPACK FOOTER //
// ./src/components/layout/Popup.js